import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { pdfLabelSetRepository } from '@webapp/modules/vendor/data-access/repositories/PDFLabelSetRepository' // eslint-disable-line import/no-internal-modules
import {
  type PDFLabelFieldMetadata,
  type PDFLabelSet,
  type PDFLabelSetConstructor,
} from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import { pdfLabelSetQueryConfig } from '@webapp/modules/vendor/query-configs/pdf-label-set' // eslint-disable-line import/no-internal-modules

export interface SavePOPDFLabelOverrideParams {
  labelSet: PDFLabelSet
  translationType: PDFLabelFieldMetadata['translationType']
  fieldKey: string
  value: string
}

export const useMutateSavePOPDFLabelOverrides = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, SavePOPDFLabelOverrideParams>({
    mutationFn: async ({
      labelSet,
      translationType,
      fieldKey,
      value,
    }: SavePOPDFLabelOverrideParams) => {
      // Whole-translation PUT with the single field patched
      const payload: PDFLabelSetConstructor = {
        isPrimary: labelSet.isPrimary,
        key: labelSet.key,
        value: {
          ...labelSet.value,
          [translationType]: {
            ...labelSet.value[translationType],
            [fieldKey]: value,
          },
        },
      }

      await pdfLabelSetRepository.update(labelSet.key, payload)
    },
    onSuccess: () => {
      // Deliberately NOT invalidating poPdfLabelEditorQueryConfig.initialSet()
      // — override edits cannot change which set is primary/first
      queryClient.invalidateQueries({
        queryKey: pdfLabelSetQueryConfig.all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
